import React, { useState,useEffect } from "react";
import correctAudio from "../../assets/sounds/correct_answer.mp3";
import incorrectAudio from "../../assets/sounds/wrong_answer.mp3";

const SelectNumComponent = ({ questionData, onOptionClick,Answer }) => {
  const { questionimagelist, imageList,questionaudio } = questionData;
  const [selectedIndex, setSelectedIndex] = useState(null);
  
  const correctSound = new Audio(correctAudio);
  const incorrectSound = new Audio(incorrectAudio);
  useEffect(() => {
      let audio = null;
  
      if (questionaudio) {
        audio = new Audio(questionaudio);
        audio.loop = false;
        audio.volume = 0.5;
  
        audio
          .play()
          .then(() => {
            console.log("Background audio started playing");
          })
          .catch((error) => {
            console.error("Error playing background audio:", error);
          });
      }
  
      return () => {
        if (audio) {
          audio.pause();
          audio.currentTime = 0;
        }
      };
    }, [questionaudio]);
  const handleOptionClick = (index) => {
    setSelectedIndex(index);
    onOptionClick(index);

    if (index === Answer) {
      correctSound.play();
    } else {
      incorrectSound.play();
    } 
  };

  return (
    <div className="flex w-[70%] mt-[20px] h-[87%] flex-col items-center justify-center font-mali">
      {questionimagelist && (
        <img className="w-[80%]" src={questionimagelist} alt="Question" />
      )}

      <div className="option-list gap-[20px] flex">
        {imageList.map((imgSrc, index) => (
          <div
            key={index}
            className="relative w-[80px] h-[80px] flex items-center justify-center cursor-pointer border-none"
            onClick={() => handleOptionClick(index)}
          >
            {selectedIndex === index && (
              <div className="absolute inset-0 bg-blue-500 opacity-50 rounded-[100%]"></div>
            )}
            <img
              src={imgSrc}
              alt={`Option ${index}`}
              className={`w-full h-full object-cover rounded-md transition-opacity duration-300 ${
                selectedIndex === index ? "opacity-50" : "opacity-100"
              }`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectNumComponent;
